import React from "react";

import TrackedLink from "src/components/TrackedLink/TrackedLink";

import { FooterProps } from "./common";

export const SuccessSignInFooter: React.FC<FooterProps> = ({ signinPath }) => (
  <div>
    {"Not logged in yet? "}
    <TrackedLink to={signinPath}>Login</TrackedLink>
  </div>
);
